import React from 'react';
import { FormattedNumber, IntlProvider } from 'react-intl';
import { getCurrencyCode } from '../helpers';
import { Currency } from '../types';
import { Wrapper } from './Price.styles';
export function Price({ cents, languageCode, overrideCurrencyFormat, superscript, maximumFractionDigits = 2, currency, }) {
    const currencyForFormattedNumber = currency || getCurrencyCode(languageCode);
    const WrappingComponent = currencyForFormattedNumber === Currency.RON ? Wrapper : React.Fragment;
    const formattedPrice = (React.createElement(WrappingComponent, null,
        React.createElement(FormattedNumber
        // eslint-disable-next-line react/style-prop-object
        , { 
            // eslint-disable-next-line react/style-prop-object
            style: "currency", value: parseFloat(String(cents)) / 100, currencyDisplay: "symbol", maximumFractionDigits: maximumFractionDigits, currency: currencyForFormattedNumber })));
    return (React.createElement(React.Fragment, null,
        overrideCurrencyFormat ? (React.createElement(IntlProvider, { locale: "de" }, formattedPrice)) : (formattedPrice),
        superscript && React.createElement("sup", null,
            " ",
            superscript)));
}
//# sourceMappingURL=Price.js.map